export const types = <const>{
	mutations: {
		NDREZ_ZAKAZKA_SELECT_MAPPER: 'NDREZ_ZAKAZKA_SELECT_MAPPER',
		NDREZ_ND_SKLAD_SELECT_MAPPER: 'NDREZ_ND_SKLAD_SELECT_MAPPER',
		NDREZ_OZAKAZKA_SELECT_MAPPER: 'NDREZ_OZAKAZKA_SELECT_MAPPER',
		NDREZ_STORE_ZAKAZKA_DATA: 'NDREZ_STORE_ZAKAZKA_DATA',
		NDREZ_SET_ZAKAZKA_DATA: 'NDREZ_SET_ZAKAZKA_DATA',
	},
};
